// extracted by mini-css-extract-plugin
module.exports = {"abattoirPrint":"abattoirAttestationTagResult_abattoirPrint__2i8xB"};